module.exports = __webpack_public_path__ + "54dfeb504cfd628863bfa55288eb6974.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GB-ZET.svg
// module id = WJnq
// module chunks = 0